import React, { useEffect, useState } from 'react';
import styles from './Message.module.css';

import { Photo } from '../Photo/Photo';
import { Name } from '../Name/Name';
import { AnimatePresence, motion } from 'framer-motion';

const Message = ({ currentMessage, isVertical }) => {
  const { message } = currentMessage;

  const [q, setQ] = useState('');

  useEffect(() => {
    setQ(message.id);
  }, [message.id]);

  return (
    <div className={styles.wrapper}>
      <AnimatePresence mode="wait">
        {q === message.id && (
          <motion.div
            className={styles.photoBlock}
            key={message.id}
            initial={{ scale: 0 }}
            animate={{ scale: 1, originX: '0', originY: '0' }}
            transition={{ duration: 0.8, delay: 0.75 }}
            exit={{
              y: '-150%',
              transition: { duration: 0.4, delay: 0 },
            }}>
            <Name message={message} />
            <Photo message={message} isVertical={isVertical} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Message;
